import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text-red text-body-2"
}

import {computed} from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'ErrorMessages',
  props: {
  errors: {
    type: Object,
  },
  name: {
    type: String,
  }
},
  setup(__props) {

const props = __props


const getErrorMessage = computed(() => {
  if (!props.errors) return false;

  if (typeof props.errors !== 'object') return false;

  if (props.name in props.errors === false) return false;

  return props.errors[props.name][0];
})

return (_ctx: any,_cache: any) => {
  return (getErrorMessage.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("p", null, _toDisplayString(getErrorMessage.value), 1)
      ]))
    : _createCommentVNode("", true)
}
}

})